import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const API_BASE = `${apiUrl}/v2/reputacion-inmuebles`;

// Quita los filtros vacíos para no mandar `?agent_id=` a la API
const limpiarParams = (filtros = {}) => {
    const params = {};
    Object.entries(filtros).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined) params[key] = value;
    });
    return params;
};

const paginacionVacia = () => ({ pagina: 1, por_pagina: 20, total: 0, ultima_pagina: 1 });

const reputacionInmuebles = {
    namespaced: true,
    state: {
        opciones: {
            alcance: null,
            inmobiliarias: [],
            agentes: [],
            ciudades: [],
            tipos_inmueble: [],
            tipos_negocio: [],
            criterios: [],
            niveles: [],
            ordenes: [],
            agrupaciones: [],
        },
        resumen: null,
        tendencia: null,
        inmuebles: { items: [], paginacion: paginacionVacia() },
        agentes: { items: [], paginacion: paginacionVacia() },
        detalle: null,
    },

    mutations: {
        setOpciones(state, data) {
            state.opciones = { ...state.opciones, ...(data || {}) };
        },
        setResumen(state, data) {
            state.resumen = data || null;
        },
        setTendencia(state, data) {
            state.tendencia = data || null;
        },
        setInmuebles(state, data) {
            state.inmuebles = {
                items: data?.items || [],
                paginacion: data?.paginacion || paginacionVacia(),
            };
        },
        setAgentes(state, data) {
            state.agentes = {
                items: data?.items || [],
                paginacion: data?.paginacion || paginacionVacia(),
            };
        },
        setDetalle(state, data) {
            state.detalle = data || null;
        },
    },

    actions: {
        async getFiltrosAction({ commit }, params = {}) {
            const response = await apiClient.get(`${API_BASE}/filtros`, { params: limpiarParams(params) });
            commit('setOpciones', response.data.data);
            return response.data.data;
        },

        async getResumenAction({ commit }, params = {}) {
            const response = await apiClient.get(`${API_BASE}/resumen`, { params: limpiarParams(params) });
            commit('setResumen', response.data.data);
            return response.data.data;
        },

        async getTendenciaAction({ commit }, params = {}) {
            const response = await apiClient.get(`${API_BASE}/tendencia`, { params: limpiarParams(params) });
            commit('setTendencia', response.data.data);
            return response.data.data;
        },

        async getInmueblesAction({ commit }, params = {}) {
            const response = await apiClient.get(`${API_BASE}/inmuebles`, { params: limpiarParams(params) });
            commit('setInmuebles', response.data.data);
            return response.data.data;
        },

        async getAgentesAction({ commit }, params = {}) {
            const response = await apiClient.get(`${API_BASE}/agentes`, { params: limpiarParams(params) });
            commit('setAgentes', response.data.data);
            return response.data.data;
        },

        async getDetalleAction({ commit }, { id, params = {} }) {
            commit('setDetalle', null);
            const response = await apiClient.get(`${API_BASE}/inmuebles/${id}`, { params: limpiarParams(params) });
            commit('setDetalle', response.data.data);
            return response.data.data;
        },

        // El CSV va con el token, por eso se pide como blob y no con un <a href>
        async exportarAction(_, params = {}) {
            const response = await apiClient.get(`${API_BASE}/exportar`, {
                params: limpiarParams(params),
                responseType: 'blob',
            });
            return response;
        },
    },
};

export default reputacionInmuebles;
